import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantContext} from '@hconnect/upm'
import {MailOutline} from '@mui/icons-material'
import {Button} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'
import {useSendBackupPlan} from '../../../../hooks/useSendBackupPlan'

export const SendBackupButton = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {plantId: plantCode} = useUpmPlantContext()
  const {mutate: sendBackupPlan, isPending: isLoading} = useSendBackupPlan()
  return (
    <Button
      startIcon={<MailOutline />}
      variant="text"
      sx={{color: 'primary.light'}}
      disabled={isLoading}
      onClick={() => sendBackupPlan({plantCode})}
      {...dataTestId('send_backup_plan_button')}
    >
      {t('planning.sendBackupPlan')}
    </Button>
  )
}
